/*@ngInject*/
const DynamicCriteriaController = function ($rootScope, $scope, $stateParams, configurationConstant, dataSetType, dataSetEditorModel, dataSetManagementUtil, currentUserModel, authorizationConstants) {
    function init() {
        // UMS-20495 workaround
        try {
            $stateParams.dataSetName = decodeURIComponent($stateParams.dataSetName);
        }
        catch (exception){
            // do nothing
        }

        var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);

        $scope.viewModel = {
            dataSet: dataSet,
            anyDependenciesSelected: false,
            isProductOrFieldDependentDynamicDataSet: parseInt($stateParams.type) === dataSetType.PRODUCT_FIELD_DEPENDENT,
            isCustomDynamicDataSet: parseInt($stateParams.type) === dataSetType.CUSTOM,
            isReadOnly: !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS)
        };

        if (!$scope.viewModel.isReadOnly) {
            addNewSourceFieldDependencyIfLastIsValid();
        }
        updateDependenciesSelected();
    }

    function removeInvalidSourceFieldDependencies() {
        var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);

        _.forEachRight(dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (sourceFieldDependency) {
            var isValidSourceFieldDependency = dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency);

            if (!isValidSourceFieldDependency) {
                dataSetEditorModel.removeSourceFieldDependency($stateParams.dataSetName, sourceFieldDependency);
            }
        });
    }

    function addNewSourceFieldDependencyIfLastIsValid() {
        var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName),
            lastSourceFieldDependencyIsValid = false,
            numberOfSourceFieldDependencies,
            noSourceFieldDependencies,
            lastSourceFieldDependency;

        if (!_.isNil(dataSet)) {
            numberOfSourceFieldDependencies = _.size(dataSet.dynamicDataSetDependency.sourceFieldDependencies);
            noSourceFieldDependencies = numberOfSourceFieldDependencies === 0;

            if (!noSourceFieldDependencies) {
                lastSourceFieldDependency = _.last(dataSet.dynamicDataSetDependency.sourceFieldDependencies);
                lastSourceFieldDependencyIsValid = dataSetManagementUtil.isValidSourceFieldDependency(lastSourceFieldDependency);
            }

            if (noSourceFieldDependencies || (lastSourceFieldDependencyIsValid && numberOfSourceFieldDependencies < configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES)) {
                dataSetEditorModel.addSourceFieldDependency($stateParams.dataSetName);
            }
        }
    }

    function updateDependenciesSelected() {
        var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName),
            anyDependenciesSelected = false,
            sourceFieldDependencies,
            numberOfSourceFieldDependencies,
            firstSourceFieldDependency;

        if (!_.isNil(dataSet)) {
            sourceFieldDependencies = dataSet.dynamicDataSetDependency.sourceFieldDependencies;
            numberOfSourceFieldDependencies = _.size(sourceFieldDependencies);
            firstSourceFieldDependency = _.first(sourceFieldDependencies);

            if (dataSet.dynamicDataSetDependency.productDependent ||
                numberOfSourceFieldDependencies > 1 ||
                (numberOfSourceFieldDependencies === 1 && dataSetManagementUtil.isValidSourceFieldDependency(firstSourceFieldDependency))) {
                anyDependenciesSelected = true;
            }
        }

        $scope.viewModel.anyDependenciesSelected = anyDependenciesSelected;
    }

    function handleDependencyChange() {
        dataSetEditorModel.setUnsavedChanges($stateParams.dataSetName, /*hasUnsavedChanges*/true);
        validateDependencies();
    }

    function validateDependencies() {
        var previousValid = dataSetEditorModel.isValidDependencies($stateParams.dataSetName),
            areDependenciesValid = true; // We currently have no necessary validation for dependencies, but if/when we do, the helper method can be called here.

        dataSetEditorModel.setValidDependencies($stateParams.dataSetName, areDependenciesValid);

        if (previousValid !== areDependenciesValid) {
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_DEPENDENCIES_UPDATED);
        }
    }

    $scope.productDependentCheckboxChanged = function () {
        updateDependenciesSelected();
        handleDependencyChange();
    };

    $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
        var dataSet;

        if ($stateParams.dataSetName === dataSetName) {
            dataSet = dataSetEditorModel.getDataSet(dataSetName);
            $scope.viewModel.dataSet = dataSet;

            if (!$scope.viewModel.isReadOnly) {
                addNewSourceFieldDependencyIfLastIsValid();
            }
            updateDependenciesSelected();
        }
    });

    $scope.$on(configurationConstant.event.DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED, function () {
        removeInvalidSourceFieldDependencies();
        addNewSourceFieldDependencyIfLastIsValid();
        updateDependenciesSelected();
        handleDependencyChange();
    });

    init();
};

angular.module('ums.configuration')
    .controller('dynamicCriteriaController', DynamicCriteriaController);
